import script from "./RosterSnackForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./RosterSnackForm.vue?vue&type=script&lang=ts&setup=true"

import "./RosterSnackForm.vue?vue&type=style&index=0&id=e2954020&lang=scss"

const __exports__ = script;

export default __exports__